// extracted by mini-css-extract-plugin
export default {"root":"_8C6wm","message":"_2lCw6","button":"_1gUS2"};